import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IKartgeometri, IKartgeometriBasdataResponse } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";

@Injectable({
    providedIn: "root"
})
export class KartaService {
    private readonly apiClient = inject(ApiClientService);

    getKartgeometriBasdata(kartgeometrityp: string, kategori: string, leveransvirke: boolean): Observable<IKartgeometriBasdataResponse> {
        const request = {
            kartgeometrityp: kartgeometrityp,
            kategori: kategori,
            leveransvirke: leveransvirke
        };
        return this.apiClient.post<any, IKartgeometriBasdataResponse>(`Geometry/GetKartgeometriBasdata`, request, true);
    }

    getKartgeometriBasdataPunkter(): Observable<IKartgeometriBasdataResponse[]> {
        return this.apiClient.get<IKartgeometriBasdataResponse[]>(`Geometry/GetKartgeometrierForPunkter`, true);
    }
    getKartgeometriBasdataLinjer(): Observable<IKartgeometriBasdataResponse[]> {
        return this.apiClient.get<IKartgeometriBasdataResponse[]>(`Geometry/GetKartgeometrierForLinjer`, true);
    }
    getKartgeometriBasdataYtor(): Observable<IKartgeometriBasdataResponse[]> {
        return this.apiClient.get<IKartgeometriBasdataResponse[]>(`Geometry/GetKartgeometrierForYtor`, true);
    }

    isDifferent(a: IKartgeometri, b: IKartgeometri): boolean {
        return a.anteckning !== b.anteckning ||
        a.barighet !== b.barighet ||
        a.etikett !== b.etikett ||
        a.geometri !== b.geometri ||
        a.hansynAtgardTyp !== b.hansynAtgardTyp ||
        a.karttext !== b.karttext ||
        a.subtyp1 !== b.subtyp1 ||
        a.subtyp2 !== b.subtyp2 ||
        a.subtyp3 !== b.subtyp3 ||
        a.tillganglighetsklass !== b.tillganglighetsklass;
    }
}

export enum Kartgeometrityper {

    Drivningspunkt = "Drivningspunkt",

    Vag = "Väg",

    Drivningslinje = "Drivningslinje",

    HansynYta = "Hänsyn yta",

    HansynPunkt = "Hänsyn punkt",

    HansynLinje = "Hänsyn linje",

    AllmanLinje = "Allmän linje",

    AllmanPunkt = "Allmän punkt",
    AnvisningYta = "Anvisning yta"
}
